import React, { useGlobal, useState, useEffect } from 'reactn';
import { DeliveryItemOverviewStyled } from './DeliveryItemOverviewStyled';
import logoImage from "../../../images/defaultLogo.svg";
import { getDeliveryManager } from '../../../services/Api';
import { formatTrackingNumber } from '../../../helpers/Helpers';

const RETAILER_IMAGE_BASE_URL = window.appMyDeliveriesRetailerImageUrl;

const DeliveryItemOverview = ({ trackingItem, deliveryManagerGet, autoDib }) => {
    const [selectedTrackingItem, setSelectedTrackingItem] = useGlobal("selectedTrackingItem");
    const [returnType] = useGlobal("globalReturnType");

    const [companyImageUrl, setCompanyImageUrl] = useState(logoImage);
    const [placeHolderMessage, setPlaceHolderMessage] = useState('');
    const [deliveryManagerMessage, setDeliveryManagerMessage] = useState('');
    const [backupTitle, setBackupTitle] = useState('');
    const [showDeliveryAddress, setShowDeliveryAddress] = useState(true);


    const formatAddress = (address) => {
        const addressParts = address.split(',');

        return addressParts.join(', ');
    };

    const handleMappingDeliveryManagerType = (deliveryManagerType) => {
        switch (deliveryManagerType) {
            case "SAFE_PLACE":
                return "Safe spot"
            case "SPECIFIED_NEIGHBOUR":
                return "To a neighbour"
            default:
                break;
        }
    }

    const handleShowDeliveryAddress = (deliveryManagerType) => {
        switch (deliveryManagerType) {
            case "SAFE_PLACE":
                setShowDeliveryAddress(true)
            case "SPECIFIED_NEIGHBOUR":
                setShowDeliveryAddress(false)
            default:
                break;
        }
    }

    // setPlaceHolderMessage(`We'll try to leave your item here if there is no answer on delivery:`)

    useEffect(() => {
        const handleAvailabilityBackupMessage = () => {
            if (trackingItem) {
                 if(trackingItem.deliveryManagerInstructionSet && trackingItem.deliveryManagerInstructionDetail) {
                if (deliveryManagerGet && !deliveryManagerGet.prevPMRequestDate) {
                    setDeliveryManagerMessage(trackingItem.deliveryManagerInstructionDetail)
                    setBackupTitle("Delivery backup")
                    setPlaceHolderMessage(`We'll try to leave your item here if there is no answer on delivery:`)
                    setShowDeliveryAddress(true)
                    return
                 }
                }
                if (deliveryManagerGet && deliveryManagerGet.prevPMRequestDetail && deliveryManagerGet.prevPMRequestType) {
                    setPlaceHolderMessage(`Your delivery backup is:`)
                    switch (deliveryManagerGet.prevPMRequestType) {
                        case "1":
                            setPlaceHolderMessage(`Safe spot:`)
                            setBackupTitle("Delivery instruction received")
                            setShowDeliveryAddress(true)
                            break;
                        case "3":
                            setPlaceHolderMessage(`Neighbour:`)
                            setBackupTitle("Delivery instruction received")
                            setShowDeliveryAddress(false)
                            break;
                        case "5":
                            setPlaceHolderMessage(`Collection Point:`)
                            setBackupTitle("Delivery instruction received")
                            setShowDeliveryAddress(false)
                            break;
                        case "6":
                            setPlaceHolderMessage(`Collection Point:`)
                            setBackupTitle("Delivery instruction received")
                            setShowDeliveryAddress(false)
                            break;
                        case "8":
                            setPlaceHolderMessage(`Another day:`)
                            setBackupTitle("Delivery instruction received")
                            setShowDeliveryAddress(true)
                            break;
                        case "12":
                            setPlaceHolderMessage(`Parcel locker:`)
                            setBackupTitle("Delivery instruction received")
                            setShowDeliveryAddress(false)
                            break;
                        default:
                            break;
                    }
                    return
                } else if (autoDib && autoDib.length) {
                    setBackupTitle("Delivery Backup")
                    handleShowDeliveryAddress(autoDib[0].deliveryManagerType)
                    if (trackingItem.deliveryManagerInstructionSet && trackingItem.deliveryManagerInstructionDetail) {

                    } else {
                        setPlaceHolderMessage("Not available for this delivery.")
                        setShowDeliveryAddress(true)
                    }
                } else {
                    setBackupTitle("Delivery Backup")
                    setPlaceHolderMessage("No delivery backup has been set")
                    setShowDeliveryAddress(true)
                }

            }
        }

        const handleBackupMessage = () => {
            if (trackingItem) {
                if (trackingItem) {
                    if (deliveryManagerGet && deliveryManagerGet.prevPMRequestDetail) {

                        setDeliveryManagerMessage(deliveryManagerGet.prevPMRequestDetail)
                        return
                    } else if (autoDib && autoDib.length) {
                        if (trackingItem.deliveryManagerInstructionSet && trackingItem.deliveryManagerInstructionDetail) {
                        } else {
                            setDeliveryManagerMessage("This may be because the sender has not provided your Eircode or they have asked us to deliver it directly to you.")
                        }
                    } else {
                        setDeliveryManagerMessage("")
                    }

                }
            }
        }

        handleAvailabilityBackupMessage();
        handleBackupMessage();
    }, [trackingItem, deliveryManagerGet, autoDib, selectedTrackingItem]);

    const handleCompanyImage = (retailerId) => {
        const imageUrl = `${RETAILER_IMAGE_BASE_URL}/${retailerId}.svg`;
        const fallbackUrl = logoImage;

        return new Promise((resolve) => {
            const img = new Image();
            img.src = imageUrl;
            img.onload = () => resolve(imageUrl);
            img.onerror = () => resolve(fallbackUrl);
        });
    };
    useEffect(() => {
        setCompanyImageUrl(logoImage)
        if (selectedTrackingItem && selectedTrackingItem.retailerId) {
            handleCompanyImage(selectedTrackingItem.retailerId).then(res => {
                if (res) {
                    setCompanyImageUrl(res)
                }
            });
        }
    }, [selectedTrackingItem]);


    return (
        <DeliveryItemOverviewStyled>
            <div className='logoWrapper'> <img src={companyImageUrl || logoImage} alt='retailer logo' /></div>
            <div className='infoPanel'>
                <div className='contentWrapper'>
                    {trackingItem && trackingItem.returnType === "RECEIVER" && <p className='title'>{trackingItem && trackingItem.retailerName}</p>}
                    {trackingItem && trackingItem.returnType === "SENDER" && <p className='title'>{trackingItem && trackingItem.retailerId ? trackingItem.retailerName : selectedTrackingItem.recipientName}</p>}
                    <p className='content'>{formatTrackingNumber(selectedTrackingItem.trackingNumber)}</p>
                </div>
                {showDeliveryAddress && trackingItem && trackingItem.recipientAddress && <div className='contentWrapper'>
                    <p className='title semiTitle'>Delivery address</p>
                    <p className='content'>{trackingItem && trackingItem.recipientAddress && formatAddress(trackingItem.recipientAddress)}  </p>
                </div>}
                {returnType === "receiving" && (
                    <div className='contentWrapper'>
                        <p className='title semiTitle'>{backupTitle}</p>
                        {autoDib && <p className='content'>{placeHolderMessage}</p>}
                        <p className='content'>{deliveryManagerMessage} </p>
                    </div>
                )}

            </div>
        </DeliveryItemOverviewStyled>
    );
};

export default DeliveryItemOverview;